<template>
  <oms-filter-content :title="title || t('features.vue.orders.filters.tags')" :is-filtering='isFiltering'>
    <span v-for='(tag, index) in modelValue?.include?.tags' :key='tag'>
      <span class='badge badge-info position-static'>{{ tag }}</span>
      <span class='ml-1 mr-1' v-if='index !== modelValue.include.tags.length - 1'>
        <template v-if='modelValue.include.filter_type === "all"'>{{ t('features.vue.shared.filters.and') }}</template>
        <template v-else>{{ t('features.vue.shared.filters.or') }}</template>
      </span>
    </span>

    <strong class='mx-1' v-if='modelValue?.exclude?.tags?.length > 0'>{{ t('features.vue.shared.filters.excluding') }}</strong>

    <span v-for='(tag, index) in modelValue?.exclude?.tags' :key='tag'>
      <span class='badge badge-info position-static'>{{ tag }}</span>
      <span class='ml-1 mr-1' v-if='index !== modelValue.exclude.tags.length - 1'>
        <template v-if='modelValue.exclude.filter_type === "all"'>{{ t('features.vue.shared.filters.and') }}</template>
        <template v-else>{{ t('features.vue.shared.filters.or') }}</template>
      </span>
    </span>
  </oms-filter-content>
</template>


<script>
import OmsFilterContent from '../filter-content.vue'
export default {
  inject: ['i18n'],

  props: {
    title: String,
    modelValue: Object
  },

  computed: {
    isFiltering() {
      return this.modelValue?.include?.tags?.length > 0 || this.modelValue?.exclude?.tags?.length > 0
    }
  },

  methods: {
    t(key, options) {
      return this.i18n ? this.i18n.t(key, options) : key
    }
  },

  components: {
    OmsFilterContent
  }
}
</script>
